module.exports = __webpack_public_path__ + "img/정수장 개요도면_2.e1bd5a6e.png";